import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({ 
  value, 
  onChange, 
  placeholder = 'Enter email body',
  rows = 6 
}) => {
  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
  }), []);

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'align',
    'link'
  ];

  return (
    <div style={{ 
      border: '1px solid #d9d9d9', 
      borderRadius: '6px', 
      overflow: 'hidden',
      backgroundColor: '#fff'
    }}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{
          minHeight: `${rows * 24}px`,
        }}
      />
      <style>{`
        .quill {
          border: none;
        }
        .ql-container {
          font-size: 14px;
          min-height: ${rows * 24}px;
        }
        .ql-editor {
          min-height: ${rows * 24}px;
          padding: 12px;
        }
        .ql-toolbar {
          border-top: none;
          border-left: none;
          border-right: none;
          border-bottom: 1px solid #d9d9d9;
          background-color: #fafafa;
          padding: 8px 12px;
        }
        .ql-toolbar .ql-stroke {
          stroke: #595959;
        }
        .ql-toolbar .ql-fill {
          fill: #595959;
        }
        .ql-toolbar button:hover,
        .ql-toolbar button.ql-active {
          color: #1890ff;
        }
        .ql-toolbar button:hover .ql-stroke,
        .ql-toolbar button.ql-active .ql-stroke {
          stroke: #1890ff;
        }
        .ql-toolbar button:hover .ql-fill,
        .ql-toolbar button.ql-active .ql-fill {
          fill: #1890ff;
        }
        .ql-editor.ql-blank::before {
          color: #bfbfbf;
          font-style: normal;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
